module.exports = __webpack_public_path__ + "static/media/loading_icon.0155f9c6.gif";